import { SelectOption } from '@fleet-beat/core';

export enum WarningType {
  CertificationWhileDriving = 'certification-while-driving',
  ChangeEngineHours = 'change-engine-hours',
  ChangeOdometer = 'change-odometer',
  DuplicatedPowerOff = 'duplicated-power-off',
  DuplicatedLogin = 'duplicated-login',
  DuplicatedLogout = 'duplicated-logout',
  IncorrectEngineHours = 'incorrect-change-engine-hours',
  IncorrectOdometer = 'incorrect-change-odometer',
  JumpLocation = 'jump-location',
  JumpOdometer = 'jump-odometer',
  NonChangeEngineHours = 'non-change-engine-hours',
  NonChangeOdometer = 'non-change-odometer',
  DuplicatePowerOn = 'duplicated-power-on',
  DrivingWhilePowerOff = 'driving-while-power-off',
  AuthConflict = 'auth-conflict',
  SSBInProgress = 'ssb-in-progress',
}

export const WarningTypeOptions: SelectOption[] = [
  {
    value: WarningType.CertificationWhileDriving,
    label: 'Certification While Driving',
    class: 'text-status-warning',
  },
  { value: WarningType.ChangeEngineHours, label: 'Change Engine Hours', class: 'text-status-warning' },
  { value: WarningType.ChangeOdometer, label: 'Change Odometer', class: 'text-status-warning' },
  { value: WarningType.DuplicatedPowerOff, label: 'Duplicated Power Off', class: 'text-status-warning' },
  { value: WarningType.DuplicatedLogin, label: 'Duplicated Login', class: 'text-status-warning' },
  { value: WarningType.DuplicatedLogout, label: 'Duplicated Logout', class: 'text-status-warning' },
  { value: WarningType.IncorrectEngineHours, label: 'Incorrect Engine Hours', class: 'text-status-warning' },
  { value: WarningType.IncorrectOdometer, label: 'Incorrect Odometer', class: 'text-status-warning' },
  { value: WarningType.JumpLocation, label: 'Location Jump', class: 'text-status-warning' },
  { value: WarningType.JumpOdometer, label: 'Odometer Jump', class: 'text-status-warning' },
  { value: WarningType.NonChangeEngineHours, label: 'Non Change Engine Hours', class: 'text-status-warning' },
  { value: WarningType.NonChangeOdometer, label: 'Non Change Odometer', class: 'text-status-warning' },
  { value: WarningType.DuplicatePowerOn, label: 'Duplicate Power On', class: 'text-status-warning' },
  { value: WarningType.DrivingWhilePowerOff, label: 'Driving While Power Off', class: 'text-status-warning' },
  { value: WarningType.AuthConflict, label: 'Login/Logout Conflict', class: 'text-status-warning' },
  { value: WarningType.SSBInProgress, label: 'SSB In Progress', class: 'text-status-warning' },
];
